<template>
  <div class="content">
    <h1>{{ pageTitle }}</h1>
    <div class="content-body two-columns form-wrapper" v-if="pcbInfo">
      <div class="left">
        <div class="block">
          <PcbInfoForm v-if="pcbInfo && pcbInfo.id" :pcb-info="pcbInfo" :is-new="false"></PcbInfoForm>
          <span style="color: #9ea7b4;" v-if="pcbInfo">{{ $t('date') }}: {{ pcbInfo.updated_at || pcbInfo.created_at }}</span>
        </div>

        <div v-if="pcbInfo && pcbInfo.category">
          <div class="block margin-top-20">
            <h2 style="margin-top: 0">{{ $t('part.info.part_number') }}</h2>
            <PartNumberForm :part="pcbInfo"></PartNumberForm>
          </div>
        </div>

        <div class="block margin-top-20">
          <h2>{{ $t('pcb.edit.specifications') }}</h2>
          <Row :gutter="32" style="display: none">
            <Col span="24">
              <UploadGerber>
                <p>Upload gerber file</p>
              </UploadGerber>
            </Col>
          </Row>
          <br>
          <PcbSpecForm @on-changed="onPcbSpecChanged"></PcbSpecForm>
        </div>
      </div>

      <div class="right">
        <div class="block">
          <h2>{{ $t('pcb.image') }}</h2>
          <div class="text-align-center">
            <Uploader v-if="pcbId" @on-success="handleFileUploaded" :defaultFileList="thumbData" :model-id="pcbId" :model-type="modelType" :max-num="1" accept=".jpg, .jpeg, .png, .gif, .svg, .bmp" drag-drop></Uploader>
          </div>
          <div class="margin-top-20">
            <Button type="primary" @click="$router.push({ name: 'menu.estimators.pcb_cost_new', query: { pcbId: pcbId }})">{{ $t('pcb.button.quote_pcb') }}</Button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex'
import { PcbSpecForm, UploadGerber, PcbInfoForm } from './components/index'
import Uploader from '@/components/images/uploader'
import PartNumberForm from '@/view/part/components/forms/part-number-form'
import { uploadThumbnail } from '@/api/file'

export default {
  name: 'PcbEdit',
  components: {
    PcbSpecForm,
    PartNumberForm,
    UploadGerber,
    PcbInfoForm,
    Uploader
  },
  data () {
    return {
      pcbInfo: null,
      pcbSpecData: {},
      showPcbCostsList: false,
      thumbData: [],
      modelType: 'manufacturer_part'
    }
  },
  computed: {
    pcbId: function () {
      return this.$route.params.partId
    },
    pageTitle: function () {
      document.title = this.$t('pcb.edit.title') + ' - ' + this.pcbInfo?.name
      return document.title
    }
  },
  mounted () {
    this.getPcbInfo(this.pcbId)
  },
  methods: {
    ...mapActions([
      'loadPcb'
    ]),
    getPcbInfo (id) {
      this.loadPcb(id).then(resp => {
        this.pcbInfo = resp.data
        this.thumbData = resp.data.thumb
      })
    },
    onPcbSpecChanged (value) {
      if (!this.$route.params.partId && value.id) {
        this.$router.push({ name: 'menu.pcb.edit', params: { partId: value.id } })
      }
      this.pcbSpecData = value.specification
    },
    handleFileUploaded (fileManaged) {
      uploadThumbnail(this.modelType, this.pcbId, fileManaged.id).then(resp => {
        this.$Message.success('Upload successfully!')
      })
    }
  },
  watch: {
    pcbId: function (newId) {
      if (newId) {
        this.getPcbInfo(newId)
      }
    }
  }
}
</script>
